// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@css/main.css";
import * as Sentry from "@sentry/vue";

import { createApp } from "vue";
import { createPinia } from "pinia";

import vueApp from "./App.vue";
import router from "./router";
import { useGlobalStore } from "./stores";

const app = createApp(vueApp);
app.use(createPinia());

const global = useGlobalStore();
await global.getEnvironment();

Sentry.init({
    app,
    dsn: global.env.SENTRY_DSN,
});

app.use(router);

app.mount("#app");
